<app-custom-dropdown *ngIf="availableLanguages && availableLanguages.length > 1"
  id="languageSwitcherDropdown"
  aria-labelledby="languageSwitcherLabel"
  (change)="selectLanguage($event)"
  [selectedOption]="locale"
  [overlayOffsetX]="45"
  data-automation-id="languageSwitcherDropdown"
  tippy="{{ selectedLanguage }}"
>
  <span custom-dropdown-label id="languageSwitcherLabel">
    <span class="d-block d-md-none">
      <span class="text-capitalize">{{ "language" | translate }}:</span>
      {{ shortLocale }}
    </span>
    <span class="d-none d-md-block px-2">
      <span class="text-capitalize">{{ "language" | translate }}:</span>
      {{ selectedLanguage }}
    </span>
  </span>
  <app-custom-dropdown-option
    *ngFor="let language of availableLanguages"
    [value]="language.code"
    [id]="language.code"
    [lang]="language.code"
    data-automation-id="languageOption">
    {{ language.name }}
  </app-custom-dropdown-option>
</app-custom-dropdown>
